import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { PrivateRoute, NotFound } from '../public';
import { Permission } from '../../types/Auth';
import { FORM_MODE } from '../../types/Form';

import ClientListContainer from './ClientListContainer';
import ClientFormContainer from './ClientFormContainer';
import ClientCopyConfigContainer from './ClientCopyConfigContainer';

const Client: React.FC = (): React.ReactElement => {
    const routeMatch = useRouteMatch();
    return (
        <Switch>
            <PrivateRoute
                exact
                path={routeMatch.path}
                comp={ClientListContainer}
                perm={Permission.CLIENT_LIST_SECTION_VIEW}
            />
            <PrivateRoute
                path={`${routeMatch.path}/:mode(${FORM_MODE.ADD}|${FORM_MODE.EDIT}|${FORM_MODE.DETAIL})/:clientId?`}
                comp={ClientFormContainer}
                perm={Permission.CLIENT_FORM_SECTION_VIEW}
            />
            <PrivateRoute
                path={`${routeMatch.path}/copy-config/:clientId?`}
                comp={ClientCopyConfigContainer}
                perm={Permission.CLIENT_FORM_SECTION_VIEW}
            />
            <Route path="*" component={NotFound} />
        </Switch>
    );
};

export default Client;
